import { Button, Screen, Text } from "components"
import React from "react"
import { View } from "react-native"
import { style } from "./styles"
import { useNavigation } from "@react-navigation/native"
import { translate } from "i18n"
import { useStores } from "models"
import flash from "config/flash"

export const EmployeeMenuScreen = () => {
  const navigation = useNavigation<any>()
  const { userStore } = useStores()
  return (
    <Screen>
      <View style={style.container}>
        <Text style={style.titleText}>{translate("loginScreen.header")}</Text>
        <Button
          onPress={() => {
            navigation.navigate("employeeEnterUser")
            // navigation.navigate("employeeUploadReceipt")
          }}
          title={translate("employeeMenuScreen.uploadReceipt")}
          style={style.mb40}
        />
        <Button
          onPress={() => {
            navigation.navigate("employeeIssueVoucher")
          }}
          title={translate("employeeMenuScreen.issueVoucher")}
          style={style.mb40}
        />
        <Button
          onPress={() => {
            navigation.navigate("employeeIssueVoucherHistory")
          }}
          title={translate("employeeMenuScreen.issueVoucherHistory")}
          style={style.mb40}
        />
        <Button
          onPress={() => {
            navigation.reset({ index: 0, routes: [{ name: "employee" }] })
            userStore?.resetAuthData()
            flash("success", translate("common.logOutSuccess"))
          }}
          title={translate("employeeMenuScreen.logout")}
        />
      </View>
    </Screen>
  )
}
